// @ts-nocheck
/**
 * Brackets — every division on one page.
 *
 * The same panel that sits under a single division, promoted out of the
 * divisions drill-down so a director can see, in one look, which divisions
 * have a bracket and which do not. Divisions with no games at all still get a
 * row: that is the row worth acting on.
 */
import * as React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, ArrowLeft } from 'lucide-react';
import BracketsPanel from '@/components/admin/schedule/BracketsPanel';
import { useDivisionNav } from '@/hooks/useDivisionNav';
import { SchedulingPageShell } from '@/components/admin/schedule/SchedulingPageShell';

export default function OperatorEventBracketsPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const { rows, event, versionId, loading, error, refresh } = useDivisionNav(eventId);
  const divisions = React.useMemo(
    () => (rows ?? []).map((r: any) => r.division).filter(Boolean),
    [rows],
  );

  return (
    <SchedulingPageShell
      title="Brackets"
      subtitle={event?.name}
      actions={
        <Button size="sm" variant="outline" asChild>
          <Link to={`/admin-dashboard/events/${eventId}/scheduling`}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Scheduling
          </Link>
        </Button>
      }
    >
      <div className="w-full space-y-4">
      {/* Only the first load blanks this page. A refresh must never replace the
          panel someone is working in — an unmounted dialog swallows the click. */}
      {loading && !versionId ? (
        <Card><CardContent className="flex items-center gap-2 py-8 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading brackets…
        </CardContent></Card>
      ) : error ? (
        <Card><CardContent className="py-8 text-sm text-destructive">{error}</CardContent></Card>
      ) : !versionId ? (
        <Card><CardContent className="space-y-3 py-8 text-sm text-muted-foreground">
          <p>Generate a draft schedule first — brackets hang off a schedule version.</p>
          <Button size="sm" asChild>
            <Link to={`/admin-dashboard/events/${eventId}/scheduling/grid`}>Open the grid</Link>
          </Button>
        </CardContent></Card>
      ) : (
        <BracketsPanel
          eventId={eventId}
          versionId={versionId}
          divisions={divisions}
          canManage
          hideHeading
          onChanged={refresh}
        />
      )}
      </div>
    </SchedulingPageShell>
  );
}
